interface UrlConfig {
  domain: string
  baseDomain: string
  isSubdomain: boolean
  subdomain: string | null
  mainAppUrl: string
  protocol: string
}

export function getUrlConfig(): UrlConfig {
  const hostname = window.location.hostname
  const port = window.location.port
  const protocol = window.location.protocol

  // Get domain from Vite env or fallback to dev default
  const domain = import.meta.env.VITE_DOMAIN || 'lvh.me:3000'
  // Extract base domain without port
  const baseDomain = domain.includes(':') ? domain.split(':')[0] : domain

  // Check if we're on a subdomain (not www, not base domain)
  const isSubdomain =
    hostname !== baseDomain &&
    hostname !== `www.${baseDomain}` &&
    hostname.endsWith(`.${baseDomain}`)

  // Extract subdomain if present
  const subdomain = isSubdomain ? hostname.replace(`.${baseDomain}`, '') : null

  // Build main app URL (without subdomain)
  const portSuffix = port && !['80', '443'].includes(port) ? `:${port}` : ''
  const mainAppUrl = `${protocol}//${baseDomain}${portSuffix}`

  return {
    domain,
    baseDomain,
    isSubdomain,
    subdomain,
    mainAppUrl,
    protocol,
  }
}

export function getProfileUrl(username: string): string {
  const { protocol, domain } = getUrlConfig()
  return `${protocol}//${username}.${domain}`
}

export function getDisplayDomain(): string {
  // Always show "profile.work" as the brand name, even in development
  return 'profile.work'
}
